export class PagePublishService {
    constructor($resource, ApiService) {
        'ngInject';

        this.$resource = $resource;
        this.apiService = ApiService;
    }

    getPagePublishStatusDetails(details) {
        return this._getPublishPageListObject(details.data.content);
    }

    setPublishPageList(menuName, list) {
        this._setResourceUrl(menuName);
        const promise = this.publishPageResource.update(this._setPublishPageListObject(list)).$promise;

        return promise.then(response => response);
    }

    /*******************************************Private Methods************************************* */
    _setResourceUrl(menuName) {
        this.publishPageResourceUrl = this.apiService.getResourceUrl(`cms/menus/${menuName}/publish`);
        this.publishPageResource = this.$resource(this.publishPageResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
    }
    _getPublishPageListObject({ values }) {
        return values.map(value => ({
            id: value.menu_id,
            isActive: value.is_active,
            title: value.title
        }));
    }

    _setPublishPageListObject(values) {
        return values.map(value => ({
            menu_id: value.id,
            is_active: value.isActive
        }));
    }
}


// WEBPACK FOOTER //
// ./src/app/components/page-publish/page-publish.service.js